import {useAppSelector} from '@lib/store';
import {Workday, OfficeWorkdayDraft} from '@lib/store/src/data/timeslots/apiTypes';
import {getConfirmedWorkspaceReservationsForWorkday} from '@lib/store/src/data/timeslots/selectors';
import {getBuildingIdsThatRequireWorkspaceBooking} from '@lib/store/src/data/timeslots/selectors/getBuildingSections';

/**
 * Workdays are considered incomplete if they are office days for a building that has mandatory desk booking enabled,
 * but there are no known registered workspace reservations attached.
 * This issue can be resolved by posting a workspace reservation to the workday
 **/
export const useWorkdayIsIncomplete = (workday: Workday | OfficeWorkdayDraft | null) => {
  const workspaceReservations = useAppSelector(getConfirmedWorkspaceReservationsForWorkday(workday?.id ?? null));
  const buildingIdsWithRequiredWorkspaceBooking = useAppSelector(getBuildingIdsThatRequireWorkspaceBooking);
  const workdayRequiresWorkspaceBooking =
    workday && 'buildingId' in workday ? buildingIdsWithRequiredWorkspaceBooking.has(workday.buildingId) : false;

  const isMutating = useAppSelector((state) => {
    const muts = state.data.timeslots.pendingMutations;

    return muts.some((m) => {
      if ('original' in m.data) {
        // Workspace reservation patch
        return m.data.original.workdayId === workday?.id;
      }

      if ('workdayId' in m.data) {
        return m.data.workdayId === workday?.id;
      }

      if ('id' in m.data) {
        return m.data.id === workday?.id;
      }
    });
  });

  const isIncompleteBooking = workdayRequiresWorkspaceBooking && workspaceReservations.length === 0;
  return isIncompleteBooking && !isMutating;
};
